
import IconChevron from '../components/icon/chevron.vue';

export default {
  components: {
    IconChevron,
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    accordionToggle() {
      // @ts-ignore
      this.active = !this.active;
    },
  },
};
